export default {
	/** Whether to preserve the original keyword. */
	preserve: false,
};
